<!-- Chat Component -->
<div class="container-fluid vh-100 bg-light d-flex flex-row">
    <!-- Sliding Panel -->
    <div id="side-panel" class="side-panel" [class.active]="isPanelActive"></div>
  
    <!-- Main Content -->
    <div id="main-content" class="main-content flex-grow-1" [class.shrink]="isPanelActive">
      <!-- Navbar -->
      <div class="navbar">
        <div class="nav-left d-flex">
          <img src="assets\img\GPT1.jpeg" alt="Logo" class="logo ms-5">
          <a href="#" class="nav-brand ms-3 fs-5 text-dark">Contoso AI Chat</a>
        </div>
        <div class="nav-center d-flex gap-2 align-items-center">
          <span class="text-dark">Model:</span>
          <select 
            class="form-select form-select-sm"
            style="width: auto;"
            [(ngModel)]="selectedModel"
            (change)="onModelChange()">
            <option [value]="model.slug" *ngFor="let model of models">
              {{ model.name }}
            </option>
          </select>
        </div>
        <div class="nav-right">
          <a href="#" class="nav-history border p-2 text-dark me-1 ms-2">
            <i class="fa-solid fa-clock-rotate-left fs-6"></i> &nbsp; History
          </a>
          <a href="#" class="nav-share me-5">
            <i class="fa-solid fa-arrow-up-right-from-square text-light"></i>&nbsp; Share
          </a>
        </div>
      </div>
  
      <!-- Content Body -->
      <div class="content-body mt-2 shadow-sm p-3 mb-5 rounded" #chatContainer>
        <!-- Image Generation Options (shown only when DALL-E is selected) -->
        <div *ngIf="isDallESelected" class="image-options-bar bg-light p-3 mb-3 rounded shadow-sm">
          <div class="row align-items-center">
            <div class="col-12 mb-2">
              <h6 class="mb-0"><i class="fa-solid fa-image"></i> Image Generation Options</h6>
            </div>
            <div class="col-md-4 col-sm-6 mb-2">
              <label class="form-label small mb-1">Size:</label>
              <select class="form-select form-select-sm" [(ngModel)]="imageSize">
                <option [value]="size.value" *ngFor="let size of imageSizes">
                  {{ size.label }}
                </option>
              </select>
            </div>
            <div class="col-md-4 col-sm-6 mb-2">
              <label class="form-label small mb-1">Quality:</label>
              <select class="form-select form-select-sm" [(ngModel)]="imageQuality">
                <option [value]="quality.value" *ngFor="let quality of imageQualities">
                  {{ quality.label }}
                </option>
              </select>
            </div>
            <div class="col-md-4 col-sm-6 mb-2">
              <label class="form-label small mb-1">Style:</label>
              <select class="form-select form-select-sm" [(ngModel)]="imageStyle">
                <option [value]="style.value" *ngFor="let style of imageStyles">
                  {{ style.label }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <!-- Welcome Message -->
        <div *ngIf="messages.length === 0" class="body-content d-flex flex-column justify-content-center align-items-center mt-2">
          <img src="assets\img\GPT1.jpeg" alt="Logo" class="body-logo mb-4">
          <h1 class="mb-2">
            <span *ngIf="!isDallESelected">Start Chatting</span>
            <span *ngIf="isDallESelected">Generate Images with DALL-E 3</span>
          </h1>
          <p *ngIf="!isDallESelected">Ask me anything!</p>
          <p *ngIf="isDallESelected">Describe the image you want to create</p>
        </div>

        <!-- Chat Messages -->
        <div class="messages-container" *ngIf="messages.length > 0">
          <ng-container *ngFor="let message of messages">
            <!-- User Message -->
            <div *ngIf="message.role === 'user'" class="message-wrapper user-message">
              <div class="message-content-wrapper">
                <div class="message-bubble">
                  <div class="message-header">
                    <strong>You</strong>
                    <span class="message-time">{{ message.timestamp | date:'short' }}</span>
                  </div>
                  <div class="message-content">
                    <p *ngIf="message.type === 'text'">{{ message.content }}</p>
                    <div *ngIf="message.type === 'image'">
                      <p class="mb-2">{{ message.content }}</p>
                      <img *ngIf="message.imageUrl" [src]="message.imageUrl" alt="Generated image" class="generated-image">
                    </div>
                  </div>
                </div>
              </div>
              <div class="avatar-wrapper user-avatar-wrapper">
                <img [src]="getProfileImageUrl()" alt="Profile" class="avatar user-avatar">
              </div>
            </div>
            <!-- Assistant Message -->
            <div *ngIf="message.role === 'assistant'" class="message-wrapper assistant-message">
              <div class="avatar-wrapper ai-avatar-wrapper">
                <img src="assets/img/GPT1.jpeg" alt="AI" class="avatar ai-avatar">
              </div>
              <div class="message-content-wrapper">
                <div class="message-bubble">
                  <div class="message-header">
                    <strong>AI Assistant</strong>
                    <span class="message-time">{{ message.timestamp | date:'short' }}</span>
                  </div>
                  <div class="message-content">
                    <p *ngIf="message.type === 'text'">{{ message.content }}</p>
                    <div *ngIf="message.type === 'image'">
                      <p class="mb-2">{{ message.content }}</p>
                      <img *ngIf="message.imageUrl" [src]="message.imageUrl" alt="Generated image" class="generated-image">
                    </div>
                  </div>
                </div>
                <button class="copy-btn" (click)="copyMessage(message.content)" title="Copy message">
                  <i class="bi bi-clipboard"></i>
                </button>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Thinking Indicator -->
        <div *ngIf="isLoading" class="thinking-container">
          <div class="message-wrapper assistant-message">
            <div class="message-bubble thinking-bubble">
              <div class="thinking-indicator">
                <div class="thinking-avatar">
                  <img src="assets/img/GPT1.jpeg" alt="AI" class="avatar-img">
                  <div class="thinking-pulse"></div>
                </div>
                <div class="thinking-content">
                  <div class="thinking-text">
                    <span class="thinking-label">AI is thinking</span>
                    <span class="thinking-dots">
                      <span>.</span><span>.</span><span>.</span>
                    </span>
                  </div>
                  <div class="thinking-wave">
                    <span></span><span></span><span></span><span></span><span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <button class="btn btn-outline-primary toggle-panel" (click)="togglePanel()">Toggle Panel</button>
  
        <!-- Input Area - Updated Design -->
        <div class="chat-input-wrapper">
          <div class="chat-input-container">
            <!-- Web Search Button -->
            <div class="input-actions">
              <button 
                class="btn-web-search" 
                type="button"
                title="Enable web search capabilities for the AI"
                [disabled]="isLoading">
                <i class="bi bi-globe"></i>
                <span class="tooltip-text">Click to enable web search capabilities for the AI</span>
              </button>
              
              <!-- Attachment Button -->
              <button 
                class="btn-attachment" 
                type="button"
                title="Attach file"
                [disabled]="isLoading">
                <i class="bi bi-paperclip"></i>
              </button>
            </div>
            
            <!-- Textarea Input -->
            <div class="textarea-wrapper">
              <textarea 
                [(ngModel)]="userInput"
                (keypress)="onKeyPress($event)"
                (input)="autoResize($event)"
                [placeholder]="isDallESelected ? 'Describe the image you want to generate...' : 'Type a new question...'" 
                class="chat-textarea"
                #chatTextarea
                rows="1"
                [disabled]="isLoading"></textarea>
            </div>
            
            <!-- Send Button -->
            <button 
              class="btn btn-send" 
              type="button"
              (click)="sendMessage()"
              [disabled]="isLoading || !userInput.trim()"
              title="Send message">
              <i class="bi bi-send-fill"></i>
            </button>
          </div>
          
          <!-- Supported Files Info -->
          <div class="input-info-row">
            <span class="supported-files-text">Supported files: Images (JPEG, PNG, WEBP). For other file types, please switch to one of the Gemini models.</span>
            <span class="token-display">Available Token: <strong>1000000</strong></span>
          </div>
        </div>
      </div>
    </div>
  </div>
